import {createApp} from "vue";
import {createPinia} from "pinia";
import Widget from './ActivityWidget.vue'
import WidgetCta from "./ActivityWidgetCta.vue";

import { setupCalendar } from 'v-calendar';
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";

const pinia = createPinia();



const widget = createApp(Widget);
widget.use(pinia);
widget.use(setupCalendar, {});
widget.use(Notifications, { velocity });
widget.mount("#sportmatch-widget");

const widgetCta = createApp(WidgetCta);
widgetCta.use(pinia);
widgetCta.use(setupCalendar, {});
widgetCta.use(Notifications, { velocity });
widgetCta.mount("#sportmatch-widget-cta")
